import {useEffect, useState} from "react";
import { Switch, Route, useLocation,matchPath, Redirect} from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { tokens as _tokens } from "./data/tokens.js";
import GifExport from './GifExport.js'
import Homepage from './Homepage.js';
import Gallery from './Gallery.js';
import About from './About.js';
import Header from './Header.js';
import Canvas from './Canvas.js';

const Modal = props => {
  const handleCloseClick = () => {
    props.passSetModal({enabled:false, message:""});
  }
  return (
    <div className="modal has-text-black is-active">
      <motion.div 
      initial={{opacity:0}}
      animate={{opacity:1}} 
      transition={{duration:0.35}}
      exit={{opacity:0}}
      className="modal-background">
      </motion.div>
      <motion.div
        initial={{y:20, opacity:0}}
        animate={{y:0, opacity:1}} 
        transition={{duration:0.3, delay:0.1}}
        exit={{y:-40, opacity:0}}
        className="modal-content sp-modal p-5">
        <p className="is-size-7">{(!props.passModal.type) ? "Ouch! Something has gone wrong!" : "Share your Spectron video" }</p>
        <p className="is-size-4 is-family-secondary mt-4">{props.passModal.message}</p>
        <button className="button is-size-7 is-primary is-rounded mt-5" onClick={handleCloseClick}>OK</button>
      </motion.div>
    </div>
  )
}

const Forbidden = props => {
  return (
    <motion.section 
      className="has-text-black"
      initial={{y:50, opacity:0}}
        animate={{y:0, opacity:1}}
        transition={{delay:0.1, duration:0.5}}  
    >
    <div className="container has-text-centered">
        <p className="is-size-1 is-size-3-mobile">Error!</p>
        <p className="is-size-7">You are not connected to the blockchain. Please connect to Metamask before trying to mint a new token.</p>
    </div>
    </motion.section>
  )
}

const Intro = props => {
  return (
  <section className="sp-loading has-text-black has-text-centered is-flex is-justify-content-center is-align-content-center">
  <div className="container has-text-centered sp-centered">
      <p className="is-size-1 is-size-3-mobile">Spectron</p>
      <p className="is-size-7">{props.loadingStatus}</p>
      <p className="sp-loader mt-4"></p>
  </div>
  </section>
  )
}

function App() {
  const location = useLocation();
  const [isGifPage, setIsGifPage] = useState(false);
  // Modal dialog
  const [modal, setModal] = useState({enabled:false, message:""});
  // Main states
  const [canvas, setCanvas] = useState({});
  const [tokens, setTokens] = useState([]);
  // Loaded state
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState("Loading data...");

  
  
  // One time effect
  useEffect(()=> {
    setLoadingStatus("Loading tokens...");
    setTokens(_tokens);
    setIsLoaded(true); 
    // GIF page handler
    let gifPage = matchPath(location.pathname, {
      path: `${process.env.PUBLIC_URL}/gif/:id/`,
      exact: true,
      strict: false
    })
    if (gifPage) setIsGifPage(true)
  }, []);

  return (
  <>
    <AnimatePresence>
    {!canvas.enabled ? null : <Canvas element={"h" + canvas.token.id} setModal={setModal} token={canvas.token} display={canvas.display} setFullscreenCanvas={setCanvas} /> }
    {!modal.enabled ? null : <Modal key="modal" passSetModal={setModal} passModal={modal} /> }
    </AnimatePresence>
    {!isLoaded ? (
      <Intro loadingStatus={loadingStatus} /> 
    ):( 
      <div className="container sp-wrapper">
        {location.pathname.includes("gif") || (
        <Header setModal={setModal} />
        )}  
          <Switch>
            <Route path={`${process.env.PUBLIC_URL}/about`}>
              <About setCanvas={setCanvas} tokenList={tokens} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/gallery`}>
              <Gallery setCanvas={setCanvas} setModal={setModal} tokenList={tokens} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/buy`}>
              <Forbidden/>
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/gif/:id`}>
              <GifExport fastload={isGifPage} tokenList={tokens} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/gif/`}>
              <Redirect to={`${process.env.PUBLIC_URL}/`} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/`}>
              <Homepage setCanvas={setCanvas} tokenList={tokens} />
            </Route>
          </Switch>
      </div>
    )}
  </>
  )
}

export default App;




